import cx from "classnames";
import { LocationDescriptorObject as To } from "history";
import { stringify } from "query-string";
import React from "react";

import { ProductEntity } from "@/mk2/apps/bazaar/schemas";
import { bazaarGridUrl } from "@/mk2/apps/bazaar/urls";
import { Link } from "@/mk2/components/Link";
import { url } from "@/mk2/helpers/urls";
import * as allProps from "@/mk/autogenerated/bzProps";
import { dict, getLabel } from "@/mk/bazaar/product/categories";
import {
    filterByCategoryAndProps,
    serializeFilterForPathname,
    serializeFilterForQuery,
} from "@/mk/bazaar/product/filter/filterUtils";

import styles from "./FilterLinks.mscss";

interface OwnProps {
    className?: string;
    product: ProductEntity;
}

type Props = OwnProps;

const FilterLinks = React.memo<Props>(({ className, product }) => {
    let highestPriorityProperty;
    const categoryProperty = product.properties.find((p) => p[0] === "cat");
    const categoryName = categoryProperty[1];
    let importantFacetTextValue = getLabel(categoryName);
    const categoryDefinition = dict()[categoryName];
    const importantProps =
        categoryDefinition !== undefined && categoryDefinition.pathnameFilters !== undefined
            ? categoryDefinition.pathnameFilters
            : [];
    if (importantProps.length) {
        highestPriorityProperty = product.properties.find((p) => p[0] === importantProps[0]);
        if (highestPriorityProperty) {
            const thisProp = allProps[categoryName][highestPriorityProperty[0]].find(
                (p) => p[0] === highestPriorityProperty[1],
            );
            importantFacetTextValue =
                thisProp !== undefined
                    ? thisProp[2]
                        ? thisProp[2]
                        : getLabel(categoryName) + " / " + thisProp[1]
                    : getLabel(categoryName);
        }
    }

    if (importantProps.length && highestPriorityProperty) {
        return (
            <div className={cx(styles.FilterLinks, className)}>
                {product.properties.map((prop, i) => {
                    if (prop[0] === "cat") {
                        return null;
                    }

                    const props = {};
                    props[importantProps[0]] = [highestPriorityProperty[1]];
                    if (prop[0] !== importantProps[0] && importantProps.indexOf(prop[0]) >= 0) {
                        props[prop[0]] = [prop[1]];
                    }
                    const catFilter = filterByCategoryAndProps(categoryName, props);
                    const to: To = {
                        pathname: url(bazaarGridUrl, {
                            category: categoryDefinition.slug,
                            filters: serializeFilterForPathname(catFilter),
                        }),
                        search: stringify(serializeFilterForQuery(catFilter)),
                    };
                    const toState = { dontScrollOnPush: true };

                    if (importantProps.indexOf(prop[0]) >= 0) {
                        if (prop[0] === importantProps[0]) {
                            return (
                                <Link
                                    key={i}
                                    to={
                                        typeof to === "string"
                                            ? { pathname: to, state: toState }
                                            : { ...to, state: { ...to.state, ...toState } }
                                    }
                                    className={styles.FilterLinks__link}
                                >
                                    {importantFacetTextValue}
                                </Link>
                            );
                        } else {
                            const thisProp = allProps[categoryName][prop[0]].find(
                                (p) => p[0] === prop[1],
                            );
                            if (thisProp && thisProp[1]) {
                                return (
                                    <Link
                                        key={i}
                                        to={
                                            typeof to === "string"
                                                ? { pathname: to, state: toState }
                                                : { ...to, state: { ...to.state, ...toState } }
                                        }
                                        className={styles.FilterLinks__link}
                                    >
                                        {importantFacetTextValue} / {thisProp[1]}
                                    </Link>
                                );
                            }
                        }
                    }
                })}
            </div>
        );
    }

    return null;
});

FilterLinks.displayName = "FilterLinks";

export default FilterLinks;
